import React from 'react';
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import { Loading, Error } from 'react-admin';
import CopyToClipboard from 'resources/common/CopyToClipboard';
import { useQuery } from 'react-admin';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import moment from 'moment';
import 'moment/locale/en-gb';

function groupRecordingsByDay(recordings) {
  if (!recordings || !Array.isArray(recordings)) return {};
  return recordings.reduce((acc, rec) => {
    if (!rec || !rec.start_time) return acc;
    const day = moment(rec.start_time).format('dddd, Do MMMM YYYY');
    if (!acc[day]) acc[day] = [];
    acc[day].push(rec);
    return acc;
  }, {});
}

function RecordingsTab({ record: cohort }) {
  const {
    data: recordings,
    loading,
    error,
  } = useQuery({
    type: 'getManyReference',
    resource: 'zoom_recordings',
    payload: {
      search: [
        {
          $match: {
            cohort_id: cohort?.id,
          },
        },
      ],
      pagination: {
        perPage: 1000,
      },
      sort: { field: 'start_time', order: 'DESC' },
    },
  });

  if (loading)
    return (
      <Box m="16px">
        <Loading />
      </Box>
    );
  if (error)
    return (
      <Box m="16px">
        <Error error={error} errorInfo={error} />
      </Box>
    );
  if (!recordings || recordings.length === 0)
    return <Box m="16px">No recordings available.</Box>;

  const grouped = groupRecordingsByDay(recordings);

  return (
    <Box>
      {Object.entries(grouped).map(([day, recs]) => (
        <Accordion key={day} style={{ margin: '8px 0' }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            style={{ backgroundColor: '#F5F5F5' }}
          >
            <Typography component="span" variant="body2">
              {day}
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ display: 'block' }}>
            <Box
              display="flex"
              component="span"
              variant="body2"
              fontWeight="semibold"
              mb={1}
              px={1}
              lineHeight="1.5"
              borderBottom="1px solid #E0E0E0"
            >
              <Box flex={1}>Start time</Box>
              <Box flex={1}>Duration (min)</Box>
              <Box flex={4}>Link</Box>
            </Box>
            {recs.map((rec) => {
              const start = rec.start_time ? moment(rec.start_time) : null;
              const duration =
                rec.duration !== undefined && rec.duration !== null
                  ? rec.duration
                  : '--';
              return (
                <Box
                  key={rec._id}
                  display="flex"
                  alignItems="center"
                  mb={1}
                  px={1}
                >
                  <Box flex={1}>
                    <Typography variant="body2">
                      {start ? start.format('HH:mm') : '--:--'}
                    </Typography>
                  </Box>
                  <Box flex={1}>
                    <Typography variant="body2">{duration}</Typography>
                  </Box>
                  <Box flex={4} display="flex" alignItems="center">
                    <Typography
                      variant="body2"
                      style={{ wordBreak: 'break-all' }}
                    >
                      {rec.share_url}
                    </Typography>
                    <CopyToClipboard text={rec.share_url} active />
                  </Box>
                </Box>
              );
            })}
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
}

export default RecordingsTab;
